import { useAuth } from "@with-nx/auth";
import { useService as service } from "@with-nx/hooks-n-helpers";
import { DesignedButton, DesignedInput, Rule } from "@with-nx/simple-ui/atoms";
import { SafeAreaAbsolutePosition } from "@with-nx/simple-ui/organisms";
import { useState } from "react";
import Toast from "react-hot-toast";
import { Box } from "simple-effing-primitive-layout";

export const GatedContentShareButton = () => {
  const auth = useAuth();
  const [code, _code] = useState<string>(null);
  const [loading, _loading] = useState(false);
  const [open, _open] = useState(false);

  const share = async () => {
    _loading(true);

    const path = window.location.pathname;

    try {
      const makeRequestToCMS = service("cms", {
        bypass: true,
        cache: 86400000,
      });

      const request = await makeRequestToCMS(
        "POST",
        "/api/v1/gated-content-unlock/share",
        {
          redirect: path,
        },
        {
          Authorization: `Bearer ${auth.authState.session.token}`,
        }
      );

      if (request?.error) {
        Toast.error(request.error);
      } else {
        _code(request.code);
      }
    } catch (error) {
      _loading(false);
    }
  };

  return (
    <Box parse="p:relative i:99">
      <DesignedButton
        theme="secondary"
        label="Share With Others"
        press={() => _open(!open)}
      />
      {open ? (
        <SafeAreaAbsolutePosition position="bottom-center">
          <Box
            parse="br:10 pa:15 c:?foreground"
            width={"calc(100vw - 30px)"}
            style={{ maxWidth: 335 }}
          >
            <Rule parse="!lm d:block mb:10">
              {code ? "🎉 Sharable Link Generated" : "Share Scene Previews"}
            </Rule>
            <Rule parse="!lt d:block mb:10">
              {code
                ? "Feel free to share this link up to 5 people, you can choose to use the options down below to share it on your social media accounts."
                : "Generate a sharable link that can be provided with up to 5 users and up to 5 days of expiration duration."}
            </Rule>
            {code ? (
              <Box css="d:flex a:flex-end">
                <Box parse="f:1 mr:10">
                  <DesignedInput
                    bottom={0}
                    label="Link"
                    size="small"
                    native={{ readOnly: true }}
                    value={`https://broadwaymedia.com/u/${code}`}
                  />
                </Box>
                <DesignedButton
                  size="small"
                  theme="secondary"
                  label="Copy"
                  press={() => {
                    navigator.clipboard.writeText(
                      `https://broadwaymedia.com/u/${code}`
                    );
                    Toast.success("Copied to clipboard");
                  }}
                />
              </Box>
            ) : (
              <DesignedButton
                label="Share"
                theme="primary"
                size="small"
                press={share}
                loading={loading}
              />
            )}
          </Box>
        </SafeAreaAbsolutePosition>
      ) : undefined}
    </Box>
  );
};

export default GatedContentShareButton;
